<div class="file-item">
	<!-- Dynamic icon based on the file type -->
	<app-file-icon [fileName]="fileName" [fileType]="fileType || 'unknown'"></app-file-icon>

	<div class="file-info">
		<span class="file-name">{{ fileName || ('fileItem.defaultName' | transloco) }}</span>
		<span class="file-size">{{ formatFileSize(fileSize) }}</span>
	</div>

	<button type="button"
		class="action-button"
		[class.download-action]="action === 'download'"
		[class.delete-action]="action === 'delete'"
		(click)="triggerAction()"
	>
		<lucide-icon [name]="getActionIcon()"></lucide-icon>
	</button>
</div>
  